import { toast } from "sonner"

import { useGenerateShortkeyLinkMutation } from "@apis/shoppers/useShoppers"
import type { TOfferType } from "@apis/offers/types"

export const useCopyShortkeyLink = () => {
  const generateShortkeyLinkMutation = useGenerateShortkeyLinkMutation()

  const copyShortkeyLink = (
    account_id: string,
    offer_code: string,
    offer_type: TOfferType,
  ) => {
    generateShortkeyLinkMutation.mutate(
      // The endpoint validates offer_type against an uppercase list.
      { account_id, offer_code, offer_type: offer_type.toUpperCase() },
      {
        onSuccess: async (response) => {
          try {
            await navigator.clipboard.writeText(response.shortkey_link)
            toast.success("Successfully copied shortkey link to clipboard!")
          } catch (error) {
            toast.error(
              `Failed to copy to clipboard. Please try again. Error: ${error}`,
            )
          }
        },
        onError: (error) => {
          toast.error(`Error generating shortkey link! ${error}`)
        },
      },
    )
  }

  return {
    copyShortkeyLink,
    isCopying: generateShortkeyLinkMutation.isPending,
  }
}
